module.exports = __webpack_public_path__ + "static/media/garri-2.06ed78b2.jpg";